import React from 'react';
import { useTranslation } from 'react-i18next';
import { UserHasPermission } from 'utils/auth/roles-and-permissions';

import { useCreateEditContractUtils } from '@/modules/workforce/Contracts/components/CreateAndEdit/logic';
import { Button, Typography } from '@/shared/components/atoms';
import DemoCTA from '@/shared/components/atoms/Demo/Modals/DemoCTA';
import { permissions } from '@/shared/constant/roles-and-permissions';
import { useAuth } from '@/shared/hooks/context/auth';
import { useStore } from '@/shared/hooks/context/createGenericContext';
import { useModal } from '@/shared/hooks/context/modalContext/useModal';

import Plus from '~/images/shared/Plus.svg';

function Header({ suppliersCount }: { suppliersCount: number | undefined }) {
  const { t } = useTranslation('common');
  const [isDemoFarm] = useStore((store) => store?.isDemoFarm);
  const { user } = useAuth();
  const { openModal } = useModal();

  const { openCreateContractModal } = useCreateEditContractUtils();

  const hasAddContractPermission = UserHasPermission({
    action: permissions.CAN_ADD_CONTRACTS,
    role: user?.userGroupId /**TODO(abdo): refactor this prop name to be `role` instead of `userGroupId` for more clarity */,
  });

  return (
    <div className='flex items-center justify-between'>
      <div className='flex flex-col gap-1'>
        <Typography variant='h1' weight='bold' className='my-16 mb-0'>
          {t('contracts')}
        </Typography>
      </div>
      <Button
        // TODO: disabled while adding
        size='lg'
        disabled={!suppliersCount && !hasAddContractPermission}
        className='rounded-xl'
        variant='filled'
        onClick={() =>
          // openModal(isDemoFarm ? <DemoCTA /> : <AddContract />, {
          //   title: t('add-contract'),
          //   containerClassName: '!overflow-visible',
          // })
          isDemoFarm ? openModal(<DemoCTA />) : openCreateContractModal()
        }
      >
        <span className='flex w-full items-center justify-center gap-2'>
          <Plus />
          <span>{t('add-contract')}</span>
        </span>
      </Button>
    </div>
  );
}

export { Header };
